import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { ActingAsBanner } from 'src/components/principal/ActingAsBanner';

const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  /* Height comes from flex stretch (cross-axis of <main>), NOT height:100%.
     On mobile <main> is a column-flex child whose grown height a percentage
     won't resolve against, so height:100% collapsed this to content height and
     nothing scrolled. min-height:0 lets the inner scroller shrink below content. */
  min-height: 0;
  overflow: hidden;
`;

export type ContentProps = {
  children: ReactNode;
};

export const Content: FC<ContentProps> = ({ children }) => {
  return (
    // id + tabIndex make this the skip-link target (WCAG 2.1 AA, 2.4.1 Bypass
    // Blocks); outline:none avoids a ring around the whole content area when it
    // receives programmatic focus from the skip link in ../main.
    // `main` is globally flex; column here so the acting-as banner (REQ-20)
    // stacks above the page. When it renders null, ContentContainer (flex:1)
    // fills the box exactly as before. (The info banners (REQ-22) live on the
    // overview page only — see self-service/routes/exact.)
    <main
      id="main-content"
      tabIndex={-1}
      style={{ outline: 'none', flexDirection: 'column' }}
    >
      <ActingAsBanner />
      <ContentContainer>{children}</ContentContainer>
    </main>
  );
};
